var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout2"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"date"},[_vm._v("数据更新时间："+_vm._s(_vm.date))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }